import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import {isEqual} from 'lodash';
import {I18n} from 'react-redux-i18n';
import DatePicker, {registerLocale} from "react-datepicker";
import {createPortal} from 'react-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import en from "date-fns/locale/en-US";
import "react-datepicker/dist/react-datepicker.css";
import "../customDateTimePicker.css";
registerLocale("en", en);
const styles = () => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    margin: 0
  },
  textField: {
    width: '100%'
  },
  popperClassName: {
    zIndex: 99999999
  }
});

export class CustomDatePicker extends React.Component {
  datePickerRef = null;
  locale = "en-US";
  langMap = {'en-us': 'en-US', 'pt-br': 'pt-BR'};
  static propTypes = {
    label: PropTypes.string,
    mode: PropTypes.string,
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    value: PropTypes.number
  }

  static defaultProps = {
    startTime: moment().subtract(29, 'days').startOf('day').valueOf(),
    endTime: moment().endOf('day').valueOf(),
    label: 'Last 30 Days'
  }

  constructor(props) {
    super(props);
    const {
      mode
    } = props;

    this.state = {
      open: false,
      mode,
      error: !props.value
    };
    this.datePickerRef = createRef();
    this.locale = localStorage.getItem('language');
    if(this.locale){
      import(`date-fns/locale/${this.langMap[this.locale] ? this.langMap[this.locale] : this.locale}/index.js`).then((val) => {
        registerLocale(this.locale, val);
      })
    }
  }

  componentWillReceiveProps(props) {
    if (!isEqual(this.props.valueInTs, props.valueInTs)) {
      const {valueInTs, min, max} = props;
      // When value is on the border values, probably, it fallbacked to it
      const error = (valueInTs < min || valueInTs > max);
      this.setState({error: error});
      this.setState({hideErrorMessage: false});
      if(error && this.props.hideErrorMessage){
        this.setState({hideErrorMessage: true});
      }
    }
  }

  isValidEntry(value) {
    const ALLOWED_CHARS_REGEXP = /^[\-0-9\b]+$/;
    return ALLOWED_CHARS_REGEXP.test(value);
  }
  handleBlur = (evt) => {
    let enteredValue = evt?.target?.value;
    const ALLOWED_CHARS_REGEXP = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
    if(enteredValue && !ALLOWED_CHARS_REGEXP.test(enteredValue)){
      this.props.onChange(this.props.value);
    }
  }
  handleChange = (value) => {
    if(typeof(value) === "object" && value.hasOwnProperty("target")){
      let enteredValue = value.target.value;
      if(!this.isValidEntry(enteredValue)){
        this.props.onChange(this.props.value);
        this.setState({error: false});
      }else{
        if(moment(enteredValue, 'YYYY-MM-DD', true).isValid()){
          this.validateDate(moment(enteredValue));
        } else {
          const ALLOWED_CHARS_REGEXP = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
          if(!ALLOWED_CHARS_REGEXP.test(enteredValue) && enteredValue.length > 10){
            this.props.onChange(this.props.value);
            this.setState({error: false});
          }
        }
      }
    } else{
      this.validateDate(value);
    }
  }


  validateDate = (value) => {
    if (value) {
      if(this.props.validateError){
        let error = true;
        let time = moment(value, 'YYYY-MM-DD');
        if (this.state.mode === 'start') {
            time = time.startOf('day');
        } else if (this.state.mode === 'end') {
            time = time.endOf('day');
        }
        time = time.valueOf();

        if (time >= this.props.min && time <= this.props.max) {
            error = false;
            this.props.onChange(time);
        } else if (time >= this.props.min) {
            this.props.onChange(this.props.max);
        } else if (time <= this.props.max) {
            this.props.onChange(this.props.min);
        }
        this.setState({error: error});
        this.setState({hideErrorMessage: false});
        if(error && this.props.hideErrorMessage){
          this.setState({hideErrorMessage: true});
        }
        if(error && this.datePickerRef){
          this.datePickerRef.current.setOpen(false);
        }
      }else{
        this.props.onChange(value);
      }
    } else {
      this.setState({error: false});
    }
  }

  render() {
    const {classes, id, validateError} = this.props;

    const DatePickerCustomInput = React.forwardRef(
      ({ value, onClick }, ref) => (
        <FormControl className={classes?.container} noValidate error>
          <TextField
            error={this.state.error}
            id="error"
            label={this.props.label}
            className={classes?.textField}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={value}
            autoComplete='off'
            InputLabelProps={{
              shrink: true
            }}
            onClick={onClick}
            ref={ref}
            inputProps={{
              min: this.props.min,
              max: this.props.max,
              pattern: '[0-9]{4}-[0-9]{2}-[0-9]{2}',
              id
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CalendarTodayIcon style={{ fontSize: 18 }}  />
                </InputAdornment>
              ),
            }}
          />
      </FormControl>
      ),
    );


    return (
      <div className={this.props.pickerClass ? this.props.pickerClass : "full-width"}>
        <DatePicker
          ref={this.datePickerRef}
          selected={this.props.valueInTs ? new Date(this.props.valueInTs) : null}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          className={classes?.textField}
          dateFormat="yyyy-MM-dd"
          popperPlacement="bottom"
          popperClassName={classes?.popperClassName}
          popperContainer={({children}) => createPortal(children,document.body)}
          minDate={moment().startOf('day').subtract(180, 'days').valueOf()}
          maxDate={moment().endOf('day').valueOf()}
          customInput={<DatePickerCustomInput />}
          locale={this.locale}
        />
        {this.state.error && !this.state.hideErrorMessage &&
          <FormHelperText error>
            {I18n.t('filter.date.error.within180days')}
          </FormHelperText>
        }
      </div>
    );
  }
}

CustomDatePicker.propTypes = {
  classes: PropTypes.shape({}).isRequired
};

export default withStyles(styles)(CustomDatePicker);
